import { render } from "./TasksBoardView.vue?vue&type=template&id=9363c028&scoped=true"
import script from "./TasksBoardView.vue?vue&type=script&lang=js"
export * from "./TasksBoardView.vue?vue&type=script&lang=js"

import "./TasksBoardView.vue?vue&type=style&index=0&id=9363c028&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9363c028"]])

export default __exports__